"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsModal = void 0;
const lucide_1 = require("lucide");
const form_1 = require("@/ui/form/form");
const settings_1 = require("@/common/settings");
const toastProvider_1 = require("@/ui/toast/toastProvider");
const i18n_1 = require("@/common/i18n");
const defaultLocalSettings_1 = __importDefault(require("@/assets/defaultLocalSettings"));
const modal_1 = require("./modal");
class SettingsModal extends modal_1.Modal {
    constructor(target) {
        super(target, { id: "settings", title: (0, i18n_1.$)("modal.settings.title"), icon: lucide_1.Settings });
        this._settings = settings_1.Settings.get();
        this._addFooterButton("save", { text: (0, i18n_1.$)("modal.settings.save"), variant: "success", icon: lucide_1.Check }, "right", () => this._save());
        this._addFooterButton("cancel", { text: (0, i18n_1.$)("modal.settings.cancel"), variant: "secondary" }, "right", () => this._cancel());
        this._addFooterButton("recover", { text: (0, i18n_1.$)("modal.settings.recover"), variant: "secondary" }, "left", () => this._recoverDefault());
        // UI
        this._form = new form_1.Form(this._container);
        this._register(this.onShow(() => {
            this._form.registerList(this._settings.getList(settings_1.SettingsType.LOCAL));
        }));
        this._register(this._settings.onDidChange(({ key }) => {
            if (key === "language") {
                window.location.reload();
            }
        }));
    }
    _save() {
        const unsavedSettings = this._form.submit();
        this._settings.storeList(unsavedSettings);
        this.close();
        toastProvider_1.toastProvider.showTitleToast("设置", "保存成功", 3000, "success");
    }
    _cancel() {
        this._form.registerList(this._settings.getList(settings_1.SettingsType.LOCAL));
        this.close();
    }
    _recoverDefault() {
        this._form.registerList(defaultLocalSettings_1.default);
        this._settings.storeList(defaultLocalSettings_1.default);
    }
}
exports.SettingsModal = SettingsModal;
